import { render, staticRenderFns } from "./UserAddresses.vue?vue&type=template&id=5479f9df&scoped=true&"
import script from "./UserAddresses.vue?vue&type=script&lang=js&"
export * from "./UserAddresses.vue?vue&type=script&lang=js&"
import style0 from "./UserAddresses.vue?vue&type=style&index=0&id=5479f9df&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5479f9df",
  null
  
)

export default component.exports